export default {
  methods: {
    toastMessage(message, type = "success") {
      this.$message({
        message,
        type,
        duration: 4000
      });
    },
    toastError(errors) {
      const error = errors[0];
      this.toastMessage(`${error.property} ${error.message}`, "error");
    }
  }
};
